import { normalizeString } from '@strata-monorepo/utils/string'

export interface EnvModel {
  environment: string | null
  incenseBackendUrl: string | undefined
}

export const envModel = (): EnvModel => ({
  environment: normalizeString(import.meta.env.VITE_ENVIRONMENT) || 'development',
  incenseBackendUrl: normalizeString(import.meta.env.VITE_INCENSE_BACKEND_URL) || undefined,
})
